/**
 * @author Coffee
 * @date 2019-08-21
 */
import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    info: {
        url: `${customerApi}/api/wework/setting`,
        type: 'GET',
    },
    update: {
        url: `${customerApi}/api/wework/setting`,
        type: 'POST',
    },
}
